import {
  WitboostCommercialModule,
  mergeArraysWithEmptyCheck,
} from '@agilelab/plugin-wb-platform-common';
import type { Features } from '@agilelab/plugin-wb-platform';

// Required commercial modules for each Supervision inner tab
export const SUPERVISION_MARKETPLACE_REQUIRED_MODULES: WitboostCommercialModule[] =
  [WitboostCommercialModule.MarketPlane];

export const SUPERVISION_PLATFORM_REQUIRED_MODULES: WitboostCommercialModule[] =
  [WitboostCommercialModule.ControlPlane];

export const getSupervisionRequiredModules = (
  features: Features,
): WitboostCommercialModule[] => {
  const enabledTabsRequiredModules: WitboostCommercialModule[][] = [];

  if (features.platformSupervisionEnabled)
    enabledTabsRequiredModules.push(SUPERVISION_PLATFORM_REQUIRED_MODULES);
  if (features.meshSupervisionEnabled)
    enabledTabsRequiredModules.push(SUPERVISION_MARKETPLACE_REQUIRED_MODULES);

  if (enabledTabsRequiredModules.length === 0) return [];
  return mergeArraysWithEmptyCheck(...enabledTabsRequiredModules);
};
